import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import useSWR from 'swr';
import { AssetClassParametersDataGrid } from '../../components/datagrid/AssetClassParametersDataGrid';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { AssetClassParameter } from '../../types/assetClassParameter.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function AssetClassParameters() {
  const history = useHistory();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({ pageName: 'Asset class parameters', steps: [{ name: 'Home', pathToCutCount: 1 }] });
    return () => {
      setValue(null);
    };
  }, []);

  const { data, error } = useSWR<AssetClassParameter[]>(
    `${API_URL.ASSET_CLASS_PARAMETER_LIST}?visibleOnly=false`,
    fetcher,
    swrConfig,
  );

  const handleEditButton = (e): void => {
    history.push(`/asset-class-parameters/edit/${e.row.data.id}`);
  };

  return (
    <PageContentWrapper error={error} loading={!data}>
      <AssetClassParametersDataGrid data={data} handleEdit={handleEditButton} />
    </PageContentWrapper>
  );
}
export default AssetClassParameters;
